function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '',
        active = swatches.querySelector('.product-card-swatch.active');

      swatch_list.forEach((swatch, index) => {

        swatch.addEventListener('mouseover', function () {

          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }

          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}
/**
 *  @class
 *  @function Header
 */
class Header {
  constructor() {
    const header = document.querySelector('.header-section'),
      header_main = document.getElementById('header'),
      a_bar = document.getElementById('shopify-section-announcement-bar')
        || document.querySelector('.announcement-bar-section'),
      menu = document.getElementById('mobile-menu'),
      toggle = document.querySelector('.mobile-toggle-wrapper'),
      overlay = document.getElementById('mobile-menu-overlay'),
      earlyMobileMenu = window.DiaMauraEarlyMobileMenu,
      setHeaderOffset = this.setHeaderOffset.bind(this),
      setAnnouncementHeight = this.setAnnouncementHeight.bind(this),
      setHeaderHeight = this.setHeaderHeight.bind(this);

    this.mobileMenuScrollLocked = false;
    this.mobileMenuScrollY = 0;
    this.mobileMenuBodyStyles = {};

    if (!header_main) {
      return;
    }
    if (!menu || !toggle) {
      return;
    }

    let scrollQueued = false;
    let resizeQueued = false;
    let isSticky = header_main.classList.contains('is-sticky');

    const updateHeaderMetrics = () => {
      if (a_bar) {
        setAnnouncementHeight(a_bar);
      }
      setHeaderHeight(header_main);
      if (header) {
        setHeaderOffset(header);
      }
      this.setFlowHeight(a_bar, header_main);
    };

    const updateHeaderOnScroll = () => {
      scrollQueued = false;

      if (!header_main.classList.contains('header-sticky--active')) {
        document.documentElement.classList.remove('da-header-has-scrolled');
        header_main.classList.remove('is-sticky');
        return;
      }

      const scrollY = Math.max(0, window.scrollY || window.pageYOffset || 0);
      const nextSticky = scrollY > 2;
      document.documentElement.classList.toggle('da-header-has-scrolled', nextSticky);

      if (nextSticky !== isSticky) {
        isSticky = nextSticky;
        header_main.classList.toggle('is-sticky', nextSticky);
      }
    };

    const requestHeaderScrollUpdate = () => {
      if (scrollQueued) return;
      scrollQueued = true;
      window.requestAnimationFrame(updateHeaderOnScroll);
    };

    const requestHeaderMetricsUpdate = () => {
      if (resizeQueued) return;
      resizeQueued = true;
      window.requestAnimationFrame(() => {
        resizeQueued = false;
        updateHeaderMetrics();
        requestHeaderScrollUpdate();
      });
    };

    updateHeaderMetrics();
    window.addEventListener('scroll', requestHeaderScrollUpdate, {
      passive: true
    });
    requestHeaderScrollUpdate();
    window.addEventListener('resize', requestHeaderMetricsUpdate, {
      passive: true
    });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', requestHeaderMetricsUpdate, {
        passive: true
      });
    }
    if ('ResizeObserver' in window) {
      this.headerResizeObserver = new ResizeObserver(requestHeaderMetricsUpdate);
      this.headerResizeObserver.observe(header_main);
      if (a_bar) {
        this.headerResizeObserver.observe(a_bar);
      }
    }

    if (!earlyMobileMenu) {
      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.closeMobileMenu(toggle, menu, overlay);
          }
        }
      });
      toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        e.preventDefault();
        if (a_bar) {
          setAnnouncementHeight(a_bar);
        }

        if (toggle.classList.contains('active')) {
          this.closeMobileMenu(toggle, menu, overlay);

        } else {
          this.openMobileMenu(toggle, menu, overlay);
        }
        window.dispatchEvent(new Event('resize.resize-select'));
      });

      // 点击遮罩层关闭移动端菜单
      if (overlay) {
        overlay.addEventListener('click', () => {
          this.closeMobileMenu(toggle, menu, overlay);
        });
      }

      // 点击X关闭按钮关闭移动端菜单
      menu.querySelectorAll('[data-mobile-menu-close]').forEach((closeBtn) => {
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.closeMobileMenu(toggle, menu, overlay);
        });
      });

      menu.querySelectorAll('[data-mobile-menu-target]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.showMobileMenuPanel(menu, button.dataset.mobileMenuTarget, button.dataset.mobileMenuTitle);
        });
      });

      menu.querySelectorAll('[data-mobile-menu-back]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.resetMobileMenuState(menu);
        });
      });
    }

    // Legacy details-based menus still use these handlers if present.
    menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
  }
  getStickyOffset(header, a_bar) {
    if (a_bar) {
      return Math.round(a_bar.offsetHeight);
    }
    if (header) {
      return Math.round(header.offsetTop || 0);
    }
    return 0;
  }
  setAnnouncementHeight(a_bar) {
    let h = Math.round(a_bar.clientHeight);
    this.setRootPixelVar('--announcement-height', h);
  }
  setHeaderOffset(header) {
    let h = Math.round(header.getBoundingClientRect().top);
    this.setRootPixelVar('--header-offset', h);
  }
  setHeaderHeight(header) {
    let h = Math.round(header.clientHeight);
    this.setRootPixelVar('--header-height', h);
  }
  setFlowHeight(a_bar, header_main) {
    let stickyEnabled = header_main.classList.contains('header-sticky--active');
    document.documentElement.classList.toggle('da-header-sticky-enabled', stickyEnabled);
    if (!stickyEnabled) {
      this.setRootPixelVar('--header-group-flow-height', 0);
      return;
    }

    let ah = a_bar ? Math.round(a_bar.clientHeight) : 0;
    let isTransparent = header_main.classList.contains('transparent--true');
    let hh = isTransparent ? 0 : Math.round(header_main.clientHeight);
    this.setRootPixelVar('--header-group-flow-height', ah + hh);
  }
  setRootPixelVar(name, value) {
    const nextValue = value + 'px';
    if (document.documentElement.style.getPropertyValue(name) !== nextValue) {
      document.documentElement.style.setProperty(name, nextValue);
    }
  }
  openMobileMenu(toggle, menu, overlay) {
    this.lockMobileMenuScroll();
    toggle.setAttribute('open', '');
    setTimeout(() => {
      toggle.classList.add('active');
      menu.classList.add('active');
      menu.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('active');
    });
  }
  closeMobileMenu(toggle, menu, overlay) {
    this.unlockMobileMenuScroll();
    toggle.classList.remove('active');
    menu.classList.remove('active');
    menu.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('active');
    this.resetMobileMenuState(menu);
    this.closeAnimation(toggle);
  }
  lockMobileMenuScroll() {
    if (this.mobileMenuScrollLocked) return;

    this.mobileMenuScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    this.mobileMenuScrollLocked = true;
    this.mobileMenuBodyStyles = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
      overflow: document.body.style.overflow
    };

    document.body.classList.add('mobile-menu-open');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + this.mobileMenuScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }
  unlockMobileMenuScroll() {
    if (!this.mobileMenuScrollLocked) {
      document.body.classList.remove('mobile-menu-open');
      return;
    }

    const restoreY = this.mobileMenuScrollY;
    const previousScrollBehavior = document.documentElement.style.scrollBehavior;

    this.mobileMenuScrollLocked = false;
    document.body.classList.remove('mobile-menu-open');
    document.body.style.position = this.mobileMenuBodyStyles.position || '';
    document.body.style.top = this.mobileMenuBodyStyles.top || '';
    document.body.style.left = this.mobileMenuBodyStyles.left || '';
    document.body.style.right = this.mobileMenuBodyStyles.right || '';
    document.body.style.width = this.mobileMenuBodyStyles.width || '';
    document.body.style.overflow = this.mobileMenuBodyStyles.overflow || '';
    this.mobileMenuBodyStyles = {};

    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, restoreY);
    document.documentElement.style.scrollBehavior = previousScrollBehavior;
  }
  resetMobileMenuState(menu) {
    if (!menu) return;
    menu.querySelectorAll('[data-mobile-menu-panel]').forEach((panel) => {
      const isRoot = panel.dataset.mobileMenuPanel === 'root';
      panel.hidden = !isRoot;
      panel.classList.toggle('is-active', isRoot);
    });
    menu.querySelectorAll('[data-mobile-menu-header]').forEach((header) => {
      const isRoot = header.dataset.mobileMenuHeader === 'root';
      header.hidden = !isRoot;
    });
    menu.querySelectorAll('[data-mobile-menu-root-only]').forEach((element) => {
      element.hidden = false;
    });
  }
  showMobileMenuPanel(menu, panelId, title) {
    if (!menu || !panelId) return;
    let nextPanel = null;
    menu.querySelectorAll('[data-mobile-menu-panel]').forEach((panel) => {
      if (panel.dataset.mobileMenuPanel === panelId) {
        nextPanel = panel;
      }
    });
    if (!nextPanel) return;
    menu.querySelectorAll('[data-mobile-menu-panel]').forEach((panel) => {
      const isActive = panel === nextPanel;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });
    menu.querySelectorAll('[data-mobile-menu-header]').forEach((header) => {
      const isRoot = header.dataset.mobileMenuHeader === 'root';
      header.hidden = isRoot;
      if (!isRoot) {
        const titleElement = header.querySelector('.diamaura-mobile-menu-header__title');
        if (titleElement) titleElement.textContent = title || '';
      }
    });
    menu.querySelectorAll('[data-mobile-menu-root-only]').forEach((element) => {
      element.hidden = true;
    });
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.link-container');
    const isOpen = detailsElement.hasAttribute('open');

    setTimeout(() => {
      detailsElement.classList.add('menu-opening');
      parentMenuElement && parentMenuElement.classList.add('submenu-open');
    }, 100);
  }
  onCloseButtonClick(event) {
    event.preventDefault();
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        detailsElement.querySelectorAll('details').forEach((details) => {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
          details.classList.remove('submenu-open');
        });
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      // 在字体加载完成前禁用导航栏过渡效果，避免 hover 时文字加载缓慢
      this.classList.add('fonts-loading');
      
      const _this = this;
      
      // 字体加载完成后启用过渡效果
      document.fonts.ready.then(function () {
        _this.classList.remove('fonts-loading');
        _this.resizeSubMenus();
      });

      if (!this.submenus.length) {
        return;
      }
      
      // resize on initial load
      window.addEventListener('resize', debounce(function () {
        _this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {

    constructor() {
      super();
      let cc = document.querySelector('.click-capture');

      // Add functionality to buttons
      this.addEventListener('click', (e) => this.close_panel(e));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          this.close_panel(e);
        }
      });
      document.addEventListener('panel:close', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
      cc.addEventListener('click', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e.target.closest('.side-panel');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer')) {
        this.close_quick_view(panel);
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    }
    close_quick_view(panel) {
      panel = panel ? panel : document.getElementById('Product-Drawer');

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            panel.querySelector('#Product-Drawer-Content').innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {

  constructor() {
    this.container = document.getElementById('Cart-Drawer');

    if (!this.container) {
      return;
    }
    let _this = this,
      button = document.getElementById('cart-drawer-toggle'),
      quantities = this.container.querySelectorAll('.quantity input');


    // Add functionality to buttons
    button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      document.body.classList.add('open-cart');
      this.container.classList.add('active');
      this.container.focus();
      setTimeout(() => {
        if (this.container.querySelector('.product-recommendations--full')) {
          this.container.querySelector('.product-recommendations--full').classList.add('active');
        }
      });
      dispatchCustomEvent('cart-drawer:open');
    });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.notesToggle();
    this.removeProductEvent();
    this.updateFreeShipping();
    // Terms checkbox
    this.termsCheckbox();
  }
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
  }
  removeProductEvent() {
    let removes = this.container.querySelectorAll('.remove');

    removes.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        this.updateQuantity(event.target.dataset.index, '0');

        event.preventDefault();
      });
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartDrawerTerms'),
      checkout_button = this.container.querySelector('.button.checkout');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
  }
  updateFreeShipping() {
    const free_shipping = this.container.querySelector('.free-shipping');

    if (free_shipping) {
      let amount_text = free_shipping.querySelector('.free-shipping--text span');
      let total = parseInt(free_shipping.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(free_shipping.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let percentage = 1;

      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
      }

      free_shipping.style.setProperty('--percentage', percentage);
    }
  }
  updateQuantity(line, quantity) {
    this.container.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    if (this.container.querySelector('.product-recommendations--full')) {
      this.container.querySelector('.product-recommendations--full').classList.remove('active');
    }
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          if (parsedState.sections) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        }));

        this.removeProductEvent();
        this.notesToggle();
        this.termsCheckbox();
        this.updateFreeShipping();
        dispatchCustomEvent('line-item:change:end', {
          quantity: quantity,
          cart: parsedState
        });

        if (this.container.querySelector(`#CartDrawerItem-${line}`)) {
          this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
        }
      });
  }
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.hide();
      }
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

/**
 *  @class
 *  @function Localization
 */
class Localization {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-localization-forms').forEach((localization) => {
      localization.addEventListener('change', (e) => {
        localization.querySelector('form').submit();
      });
    });
  }
}



/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  const quickViewCache = new Map();
  const diamauraQuickViewMediaCache = new Map();

  const getDiamauraDateSuffix = (day) => {
    if (day > 3 && day < 21) return 'th';

    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  const getDiamauraDeliveryEstimate = () => {
    if (window.luxon && window.luxon.DateTime) {
      const nowInPT = window.luxon.DateTime.now().setZone('America/Los_Angeles');
      const hoursUntilMidnight = Math.max(1, Math.floor(nowInPT.endOf('day').diff(nowInPT, 'hours').hours));
      const futureDate = nowInPT.plus({ days: 21 });

      return {
        hours: hoursUntilMidnight,
        date: `${futureDate.toFormat('LLLL')} ${futureDate.day}${getDiamauraDateSuffix(futureDate.day)}`
      };
    }

    const nowInPT = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));
    const endOfDay = new Date(nowInPT);
    endOfDay.setHours(23, 59, 59, 999);

    const hoursUntilMidnight = Math.max(1, Math.floor((endOfDay - nowInPT) / 36e5));
    const futureDate = new Date(nowInPT);
    futureDate.setDate(futureDate.getDate() + 21);

    const month = futureDate.toLocaleString('en-US', { month: 'long' });
    const day = futureDate.getDate();

    return {
      hours: hoursUntilMidnight,
      date: `${month} ${day}${getDiamauraDateSuffix(day)}`
    };
  };

  const updateDiamauraDeliveryEstimates = (root = document) => {
    const estimates = root.querySelectorAll('[data-diamaura-delivery-estimate]');

    if (!estimates.length) {
      return;
    }

    const estimate = getDiamauraDeliveryEstimate();

    estimates.forEach((container) => {
      const hours = container.querySelector('[data-delivery-hours]');
      const date = container.querySelector('[data-delivery-date]');

      if (hours) {
        hours.textContent = estimate.hours;
      }

      if (date) {
        date.textContent = estimate.date;
      }
    });
  };

  let diamauraQuickViewGalleryEventsBound = false;

  const getDiamauraGalleryItems = (root) => Array.from(root.querySelectorAll('[data-gallery-thumb]:not([hidden])'));

  const setDiamauraQuickViewGalleryMedia = (root, mediaId) => {
    if (!mediaId) {
      return;
    }

    const slides = root.querySelectorAll('.product-quick-images__slide[data-media-id]');
    const thumbs = root.querySelectorAll('[data-gallery-thumb]');
    const targetSlide = root.querySelector(`.product-quick-images__slide[data-media-id="${mediaId}"]`);

    if (!targetSlide) {
      return;
    }

    slides.forEach((slide) => {
      const isActive = slide.dataset.mediaId === mediaId;
      slide.classList.toggle('is-active', isActive);

      if (!isActive) {
        slide.querySelectorAll('video').forEach((video) => video.pause());
      }
    });
    thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId));

    const activeThumb = root.querySelector(`[data-gallery-thumb][data-media-id="${mediaId}"]`);

    if (activeThumb && !(root.classList.contains('product-drawer--bracelet-v2') && window.innerWidth < 1068)) {
      const thumbsContainer = activeThumb.closest('.diamaura-quick-view-gallery__thumbs');
      if (thumbsContainer) {
        const centeredLeft = activeThumb.offsetLeft - (thumbsContainer.clientWidth - activeThumb.offsetWidth) / 2;
        thumbsContainer.scrollTo({
          left: Math.max(0, centeredLeft),
          behavior: 'smooth'
        });
      }
    }
  };

  const syncDiamauraQuickViewGallery = (root) => {
    const activeSlide = root.querySelector('.product-quick-images__slide.is-active[data-media-id]');
    const firstSlide = root.querySelector('.product-quick-images__slide[data-media-id]');

    setDiamauraQuickViewGalleryMedia(root, activeSlide?.dataset.mediaId || firstSlide?.dataset.mediaId);
  };

  const normalizeDiamauraMediaText = (value) => (value || '').toString().toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

  const getDiamauraMediaAlt = (slide) => slide.dataset.mediaAlt || slide.querySelector('img')?.getAttribute('alt') || '';

  const getDiamauraMetalSearchTerms = (option) => {
    const normalizedOption = normalizeDiamauraMediaText(option);
    const terms = [normalizedOption];

    if (/\brose\b/.test(normalizedOption)) {
      terms.push('rose gold', 'rose');
    }

    if (/\byellow\b/.test(normalizedOption)) {
      terms.push('yellow gold', 'yellow');
    }

    if (/\bwhite\b/.test(normalizedOption)) {
      terms.push('white gold', 'white');
    }

    if (/\bplatinum\b/.test(normalizedOption)) {
      terms.push('platinum');
    }

    if (/\bsilver\b/.test(normalizedOption)) {
      terms.push('silver');
    }

    return [...new Set(terms)];
  };

  const findDiamauraQuickViewMediaByVariantAlt = (root, variant) => {
    const slides = Array.from(root.querySelectorAll('.product-quick-images__slide[data-media-id]'));

    if (!slides.length || !variant?.options?.length) {
      return null;
    }

    const metalOptions = variant.options
      .map((option) => option.toString().trim())
      .filter((option) => /gold|platinum|silver/i.test(option))
      .sort((a, b) => b.length - a.length);

    for (const option of metalOptions) {
      const searchTerms = getDiamauraMetalSearchTerms(option);
      const match = slides.find((slide) => {
        const mediaAlt = normalizeDiamauraMediaText(getDiamauraMediaAlt(slide));

        return searchTerms.some((term) => mediaAlt.includes(term));
      });

      if (match) {
        return match.dataset.mediaId;
      }
    }

    return null;
  };

  const updateDiamauraQuickViewGalleryFromVariant = (root, variant, sectionId) => {
    const altMediaId = findDiamauraQuickViewMediaByVariantAlt(root, variant);

    if (altMediaId) {
      setDiamauraQuickViewGalleryMedia(root, altMediaId);
    } else if (variant?.featured_media?.id && sectionId) {
      setDiamauraQuickViewGalleryMedia(root, `${sectionId}-${variant.featured_media.id}`);
    } else {
      syncDiamauraQuickViewGallery(root);
    }
  };

  const formatDiamauraQuickViewMoney = (cents) => {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents, window.theme?.settings?.money_with_currency_format);
    }

    return `$${(cents / 100).toFixed(2)}`;
  };

  const updateDiamauraQuickViewPrice = (root, variant, sectionId) => {
    if (!variant || !sectionId) {
      return;
    }

    const priceContainer = root.querySelector(`#price-${sectionId}`);

    if (!priceContainer) {
      return;
    }

    const price = variant.price;
    const compareAtPrice = variant.compare_at_price;
    const isOnSale = compareAtPrice && compareAtPrice > price;

    priceContainer.classList.remove('visibility-hidden');
    priceContainer.innerHTML = `
      <span class="price">
        ${isOnSale ? `<del><span class="amount">${formatDiamauraQuickViewMoney(compareAtPrice)}</span></del>` : ''}
        <ins><span class="amount">${formatDiamauraQuickViewMoney(price)}</span></ins>
        ${variant.available ? '' : '<span class="badges"><span class="badge out-of-stock">Sold out</span></span>'}
      </span>
    `;
  };

  const updateDiamauraQuickViewVariantUI = (root, variant, sectionId) => {
    filterDiamauraQuickViewVideos(root, variant);
    updateDiamauraQuickViewGalleryFromVariant(root, variant, sectionId);
    updateDiamauraQuickViewPrice(root, variant, sectionId);
  };

  const getDiamauraQuickViewSelectedOptions = (variantSelects) => {
    return Array.from(variantSelects.querySelectorAll('fieldset')).map((fieldset) => {
      const select = fieldset.querySelector('select');
      const checked = fieldset.querySelector('input:checked');

      return select ? select.value : checked?.value;
    });
  };

  const getDiamauraQuickViewVariantData = (variantSelects) => {
    const json = variantSelects.querySelector('script[type="application/json"]');

    if (!json) {
      return [];
    }

    try {
      return JSON.parse(json.textContent);
    } catch (error) {
      return [];
    }
  };

  const getDiamauraQuickViewCurrentVariant = (variantSelects) => {
    if (!variantSelects) {
      return null;
    }

    const selectedOptions = getDiamauraQuickViewSelectedOptions(variantSelects);

    if (!selectedOptions.length || selectedOptions.includes(undefined)) {
      return null;
    }

    return getDiamauraQuickViewVariantData(variantSelects).find((variant) => {
      return variant.options.every((option, index) => selectedOptions[index] === option);
    });
  };

  const getDiamauraQuickViewVideoSource = (media) => {
    const mediaType = (media?.media_type || media?.mediaType || media?.contentType || media?.type || '')
      .toString()
      .toUpperCase();

    if (mediaType !== 'VIDEO') {
      return null;
    }

    const sources = Array.isArray(media?.sources)
      ? media.sources
      : media?.sources?.nodes || [];
    const source = sources.find((item) => (
      (item?.mime_type || item?.mimeType || '').toString().toLowerCase() === 'video/mp4'
    )) || sources.find((item) => item?.url || item?.src) || {};
    const src = source.url || source.src || media?.source?.url || media?.source?.src || media?.url || media?.src;

    if (!src) {
      return null;
    }

    const filename = media?.filename || media?.fileName || src.split('/').pop() || '';
    const metalCode = filename.toUpperCase().match(/(?:^|[^A-Z0-9])(14K[WRY]|18K[WRY]|PT)(?:[^A-Z0-9]|$)/)?.[1] || '';

    return {
      src: src.startsWith('//') ? `https:${src}` : src,
      filename,
      metalCode
    };
  };

  const getDiamauraQuickViewVideoRequest = (gallery) => {
    const endpoint = gallery?.dataset.mediaApiEndpoint;
    const productHandle = gallery?.dataset.productHandle;

    if (!endpoint || !productHandle) {
      return null;
    }

    const cacheKey = `${endpoint}|${productHandle}`;

    if (diamauraQuickViewMediaCache.has(cacheKey)) {
      return diamauraQuickViewMediaCache.get(cacheKey);
    }

    const url = new URL(endpoint, window.location.origin);
    url.searchParams.set('count', '1');
    url.searchParams.set('next_start_at', '0');
    url.searchParams.set('handle', productHandle);

    const request = fetch(url, {
      headers: { Accept: 'application/json' }
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Quick view media request failed for ${productHandle}`);
        }

        return response.json();
      })
      .then((payload) => {
        const detail = payload?.data?.engagementRingsProductPoList?.[0]
          || payload?.engagementRingsProductPoList?.[0];
        const extraMedias = Array.isArray(detail?.extraMedias)
          ? detail.extraMedias
          : detail?.extraMedias?.nodes || [];
        const seen = new Set();

        return extraMedias
          .map(getDiamauraQuickViewVideoSource)
          .filter((video) => {
            if (!video || seen.has(video.src)) {
              return false;
            }

            seen.add(video.src);
            return true;
          });
      })
      .catch((error) => {
        diamauraQuickViewMediaCache.delete(cacheKey);
        throw error;
      });

    diamauraQuickViewMediaCache.set(cacheKey, request);
    return request;
  };

  const getDiamauraQuickViewMetalCodes = (variant) => {
    const metal = variant?.options?.find((option) => /gold|platinum/i.test(option)) || '';

    if (/platinum/i.test(metal)) {
      return { exact: ['PT'], family: ['18KW', '14KW'] };
    }

    const karat = metal.match(/\b(14|18)K\b/i)?.[1];
    const color = /rose/i.test(metal) ? 'R' : /yellow/i.test(metal) ? 'Y' : /white/i.test(metal) ? 'W' : '';

    if (!karat || !color) {
      return { exact: [], family: [] };
    }

    const exact = `${karat}K${color}`;
    const family = [`14K${color}`, `18K${color}`].filter((code) => code !== exact);

    return { exact: [exact], family };
  };

  const filterDiamauraQuickViewVideos = (root, variant) => {
    const videoThumbs = Array.from(root.querySelectorAll('[data-gallery-thumb][data-extra-video]'));

    if (!videoThumbs.length) {
      return;
    }

    const metalCodes = getDiamauraQuickViewMetalCodes(variant);
    const genericVideos = videoThumbs.filter((thumb) => !thumb.dataset.videoMetalCode);
    const exactVideos = videoThumbs.filter((thumb) => metalCodes.exact.includes(thumb.dataset.videoMetalCode));
    const familyVideos = videoThumbs.filter((thumb) => metalCodes.family.includes(thumb.dataset.videoMetalCode));
    const selectedVideos = exactVideos.length
      ? [...exactVideos, ...genericVideos]
      : familyVideos.length
        ? [...familyVideos, ...genericVideos]
        : videoThumbs;
    const visibleMediaIds = new Set(selectedVideos.map((thumb) => thumb.dataset.mediaId));

    root.querySelectorAll('[data-extra-video][data-media-id]').forEach((element) => {
      element.hidden = !visibleMediaIds.has(element.dataset.mediaId);
    });

    const activeSlide = root.querySelector('.product-quick-images__slide.is-active');

    if (activeSlide?.hidden) {
      const firstVisibleThumb = root.querySelector('[data-gallery-thumb]:not([hidden])');
      setDiamauraQuickViewGalleryMedia(root, firstVisibleThumb?.dataset.mediaId);
    }
  };

  const appendDiamauraQuickViewVideos = (root, videos) => {
    const gallery = root.querySelector('.product-quick-images--container');
    const slides = gallery?.querySelector('.product-quick-images');
    const thumbs = gallery?.querySelector('.diamaura-quick-view-gallery__thumbs');

    if (!gallery || !slides || !thumbs || !videos.length) {
      return;
    }

    const existingSources = new Set(Array.from(slides.querySelectorAll('video')).map((video) => video.currentSrc || video.src));
    const firstImage = slides.querySelector('.product-quick-images__slide img');
    const poster = firstImage?.currentSrc || firstImage?.src || '';
    const label = gallery.dataset.videoLabel || 'Play video';
    const firstNav = slides.querySelector('[data-gallery-prev], [data-gallery-next]');

    videos.forEach((video, index) => {
      if (existingSources.has(video.src)) {
        return;
      }

      existingSources.add(video.src);
      const mediaId = `diamaura-extra-video-${index}`;
      const slide = document.createElement('div');
      const media = document.createElement('div');
      const videoElement = document.createElement('video');
      const thumb = document.createElement('button');
      const thumbImage = document.createElement('img');
      const playBadge = document.createElement('span');

      slide.id = `Slide-${mediaId}`;
      slide.className = 'product-quick-images__slide';
      slide.dataset.mediaId = mediaId;
      slide.dataset.mediaAlt = video.filename;
      slide.dataset.extraVideo = '';
      slide.dataset.videoMetalCode = video.metalCode;

      media.className = 'product-single__media product-single__media-native-video';
      media.dataset.mediaId = mediaId;
      videoElement.src = video.src;
      videoElement.controls = true;
      videoElement.preload = 'metadata';
      videoElement.playsInline = true;
      if (poster) {
        videoElement.poster = poster;
      }
      media.append(videoElement);
      slide.append(media);
      slides.insertBefore(slide, firstNav);

      thumb.className = 'diamaura-quick-view-gallery__thumb diamaura-quick-view-gallery__thumb--video';
      thumb.type = 'button';
      thumb.dataset.galleryThumb = '';
      thumb.dataset.mediaId = mediaId;
      thumb.dataset.mediaAlt = video.filename;
      thumb.dataset.extraVideo = '';
      thumb.dataset.videoMetalCode = video.metalCode;
      thumb.setAttribute('aria-label', `${label} ${index + 1}`);
      if (poster) {
        thumbImage.src = poster;
        thumbImage.alt = '';
        thumbImage.loading = 'lazy';
        thumb.append(thumbImage);
      }
      playBadge.className = 'diamaura-quick-view-gallery__video-badge';
      playBadge.setAttribute('aria-hidden', 'true');
      playBadge.textContent = '▶';
      thumb.append(playBadge);
      thumbs.append(thumb);
    });
  };

  const loadDiamauraQuickViewVideos = (root) => {
    const gallery = root.querySelector('.product-quick-images--container');

    if (!gallery || gallery.dataset.extraVideoStatus) {
      return;
    }

    const request = getDiamauraQuickViewVideoRequest(gallery);

    if (!request) {
      gallery.dataset.extraVideoStatus = 'unavailable';
      return;
    }

    gallery.dataset.extraVideoStatus = 'loading';
    request
      .then((videos) => {
        if (!gallery.isConnected) {
          return;
        }

        appendDiamauraQuickViewVideos(root, videos);
        const variantSelects = root.querySelector('variant-selects');
        filterDiamauraQuickViewVideos(root, getDiamauraQuickViewCurrentVariant(variantSelects));
        gallery.dataset.extraVideoStatus = videos.length ? 'ready' : 'empty';
      })
      .catch(() => {
        if (gallery.isConnected) {
          gallery.dataset.extraVideoStatus = 'error';
        }
      });
  };

  const updateDiamauraQuickViewVariantInput = (root, variant) => {
    if (!variant) {
      return;
    }

    root.querySelectorAll('product-form form input[name="id"], form.installment input[name="id"]').forEach((input) => {
      input.value = variant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  const updateDiamauraQuickViewOptionLabels = (variantSelects) => {
    Array.from(variantSelects.querySelectorAll('fieldset')).forEach((fieldset) => {
      const labelValue = fieldset.querySelector('.form__label__value');
      const select = fieldset.querySelector('select');
      const checked = fieldset.querySelector('input:checked');
      const value = select ? select.value : checked?.value;

      if (labelValue && value !== undefined) {
        labelValue.textContent = value;
      }
    });
  };

  const updateDiamauraQuickViewFromControls = (root) => {
    const variantSelects = root.querySelector('variant-selects');

    if (!variantSelects) {
      return;
    }

    updateDiamauraQuickViewOptionLabels(variantSelects);

    const variant = getDiamauraQuickViewCurrentVariant(variantSelects);

    if (!variant) {
      return;
    }

    variantSelects.currentVariant = variant;
    updateDiamauraQuickViewVariantInput(root, variant);
    updateDiamauraQuickViewVariantUI(root, variant, variantSelects.dataset.section);
  };

  const moveDiamauraQuickViewGallery = (root, direction) => {
    const thumbs = getDiamauraGalleryItems(root);

    if (!thumbs.length) {
      return;
    }

    const activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
    const nextIndex = (activeIndex + direction + thumbs.length) % thumbs.length;

    setDiamauraQuickViewGalleryMedia(root, thumbs[nextIndex].dataset.mediaId);
  };

  const setupDiamauraQuickViewGallery = (root) => {
    const gallery = root.querySelector('.product-quick-images--container');

    if (!gallery || gallery.dataset.galleryReady === 'true') {
      syncDiamauraQuickViewGallery(root);
      return;
    }

    gallery.dataset.galleryReady = 'true';
    let touchStartX = 0;
    let touchStartY = 0;

    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-gallery-thumb]');
      const prev = event.target.closest('[data-gallery-prev]');
      const next = event.target.closest('[data-gallery-next]');

      if (thumb) {
        setDiamauraQuickViewGalleryMedia(root, thumb.dataset.mediaId);
        return;
      }

      if (prev) {
        moveDiamauraQuickViewGallery(root, -1);
        return;
      }

      if (next) {
        moveDiamauraQuickViewGallery(root, 1);
      }
    });

    gallery.addEventListener('touchstart', (event) => {
      if (!(root.classList.contains('product-drawer--bracelet-v2') && window.innerWidth < 1068)) {
        return;
      }

      const touch = event.touches?.[0];

      if (!touch) {
        return;
      }

      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
    }, { passive: true });

    gallery.addEventListener('touchend', (event) => {
      if (!(root.classList.contains('product-drawer--bracelet-v2') && window.innerWidth < 1068)) {
        return;
      }

      const touch = event.changedTouches?.[0];

      if (!touch) {
        return;
      }

      const deltaX = touch.clientX - touchStartX;
      const deltaY = touch.clientY - touchStartY;

      if (Math.abs(deltaX) > 42 && Math.abs(deltaX) > Math.abs(deltaY) * 1.4) {
        moveDiamauraQuickViewGallery(root, deltaX < 0 ? 1 : -1);
      }
    }, { passive: true });

    const variantSelects = root.querySelector('variant-selects');

    if (variantSelects) {
      variantSelects.addEventListener('change', () => {
        window.setTimeout(() => {
          updateDiamauraQuickViewFromControls(root);
        });
      });
    }

    root.addEventListener('click', (event) => {
      if (!event.target.closest('variant-selects label, variant-selects input, variant-selects select')) {
        return;
      }

      window.setTimeout(() => {
        updateDiamauraQuickViewFromControls(root);
      });
    });

    syncDiamauraQuickViewGallery(root);
    loadDiamauraQuickViewVideos(root);

    if (!diamauraQuickViewGalleryEventsBound) {
      diamauraQuickViewGalleryEventsBound = true;
      document.addEventListener('product:variant-change', (event) => {
        const drawer = document.getElementById('Product-Drawer');

        if (!drawer || !drawer.classList.contains('active')) {
          return;
        }

        updateDiamauraQuickViewVariantUI(drawer, event.detail?.variant, event.detail?.sectionId);
      });
    }
  };

  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.addEventListener('pointerenter', this.prefetchQuickview.bind(this), { once: true });
      this.addEventListener('touchstart', this.prefetchQuickview.bind(this), { once: true, passive: true });
      this.addEventListener('focus', this.prefetchQuickview.bind(this), { once: true });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          this.setupEventListener(e);
        }
      });

    }
    getQuickviewRequest() {
      const productHandle = this.dataset.productHandle;

      if (!productHandle) {
        return null;
      }

      let href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;
      href = href.replace('//', '/');

      if (quickViewCache.has(productHandle)) {
        return quickViewCache.get(productHandle);
      }

      const request = fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Quick view request failed for ${productHandle}`);
          }

          return response.text();
        })
        .then((text) => ({
          href,
          productHandle,
          text
        }))
        .catch((error) => {
          quickViewCache.delete(productHandle);
          throw error;
        });

      quickViewCache.set(productHandle, request);

      return request;
    }
    shouldGoToProductPage() {
      return Boolean(this.dataset.productUrl) && window.innerWidth < 1068;
    }
    prefetchQuickview() {
      if (this.shouldGoToProductPage()) {
        return;
      }

      const request = this.getQuickviewRequest();

      if (request) {
        request.catch(() => {});
      }
    }
    setupEventListener(e) {
      e.preventDefault();

      if (this.shouldGoToProductPage()) {
        window.location.href = this.dataset.productUrl;
        return;
      }

      const request = this.getQuickviewRequest();

      if (!request) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      request
        .then(({ text, href, productHandle }) => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);
        })
        .finally(() => {
          this.classList.remove('loading');
        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;
        const drawerContent = this.drawer.querySelector('.side-panel-content');
        updateDiamauraDeliveryEstimates(this.drawer);
        setupDiamauraQuickViewGallery(this.drawer);
        if (drawerContent) {
          drawerContent.scrollTop = 0;
        }

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          this.drawer.querySelector('.product-quick-images--container').classList.add('active');
        });
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        setTimeout(() => {
          this.prepareAnimations();
          this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
        }, 400);
      }
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector('summary').offsetHeight,
        content_height = this.querySelector('.collapsible__content').offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height;

      this.tl = false;
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: 'sine.inOut',
        onStart: function () {
          _this.details.open = true;
          console.log(_this.details.querySelector("summary"), 'summary');
          _this.details.style.overflow = 'hidden';
          _this.details.querySelector("summary").style.color = "#000";
          _this.details.querySelector("summary").style.fontWeight = "500";
        },
        onReverseComplete: function () {
          _this.details.open = false;
          _this.details.querySelector("summary").style.color = "#646464";
          _this.details.querySelector("summary").style.fontWeight = "400";
          _this.details.style.overflow = '';
        }
      });

      this.tl
        .fromTo(_this.details, {
          height: function () {
            let h = Math.max(Math.max(initial_height, 0), 24);
            return h;
          },
          clearProps: 'height'
        }, {
          duration: 0.6,
          height: final_height,
          clearProps: 'height'
        });

      if (this.details.open) {
        this.tl.progress(1);
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      e.preventDefault();
      if (this.tl.reversed()) {
        this.tl.timeScale(1).play();
      } else {
        this.tl.timeScale(3).reverse();
      }
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}
/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;

      if (!handle) {
        return;
      }
    }
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof (recentIds) !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {

  if (typeof Localization !== 'undefined') {
    new Localization();
  }
  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer();
  }
  if (typeof Header !== 'undefined') {
    new Header();
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});

window.onload = function () {
  // 获取并存储当前页面的 URL
  const currentURL = window.location.href;
  sessionStorage.setItem('previousURL', currentURL);
};

/* <estimated-ship-date> (the cart delivery card) now lives in
   webcomponents/src/estimated-ship-date/ and ships as estimated-ship-date.js,
   so it shares the delivery schedule with the product pages. */


const copyTextToClipboard = async (text) => {
  if (!text) return false;

  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return true;
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '-9999px';
  document.body.appendChild(textarea);
  textarea.select();
  const copied = document.execCommand('copy');
  document.body.removeChild(textarea);
  return copied;
};

let dmFooterCopyStatusTimer = null;

document.addEventListener('click', async (event) => {
  const trigger = event.target.closest('.dm-footer [data-copy-email]');

  if (!trigger) return;

  event.preventDefault();

  const email = trigger.getAttribute('data-copy-email');
  const statusId = trigger.getAttribute('aria-describedby');
  const status = statusId ? document.getElementById(statusId) : document.querySelector('.dm-footer__copy-status');

  const showStatus = (message) => {
    if (!status) return;
    status.textContent = message;
    status.classList.add('is-visible');
    if (dmFooterCopyStatusTimer) window.clearTimeout(dmFooterCopyStatusTimer);
    dmFooterCopyStatusTimer = window.setTimeout(() => {
      status.classList.remove('is-visible');
    }, 1800);
  };

  try {
    const copied = await copyTextToClipboard(email);
    showStatus(copied ? 'Copied' : `Email address: ${email}`);
  } catch (error) {
    showStatus(`Email address: ${email}`);
  }
});

document.addEventListener('click', async (event) => {
  const trigger = event.target.closest('[data-copy-product-link]');

  if (!trigger) return;

  event.preventDefault();

  const href = trigger.dataset.copyProductLink || trigger.getAttribute('href');
  const productUrl = href ? new URL(href, window.location.origin).toString() : '';

  try {
    const copied = await copyTextToClipboard(productUrl);
    if (copied) {
      trigger.classList.add('is-copied');
      trigger.setAttribute('aria-label', 'Product link copied');
      window.setTimeout(() => {
        trigger.classList.remove('is-copied');
        trigger.setAttribute('aria-label', 'Copy product link');
      }, 1600);
    }
  } catch (error) {
    console.error('Unable to copy product link:', error);
  }
});



document.addEventListener('DOMContentLoaded', function() {
  const chatLink = document.querySelector('a[href="/?chat"]');

  if (chatLink) {
    chatLink.addEventListener('click', function(event) {
      event.preventDefault();
      try {
        const shopifyChatHost = document.querySelector('inbox-online-store-chat');
        if (shopifyChatHost && shopifyChatHost.shadowRoot) {
          const chatToggleButton = shopifyChatHost.shadowRoot.querySelector('button.chat-toggle');
          if (chatToggleButton) {
            chatToggleButton.click();
          } else {
            console.error('Shopify Inbox: Internal chat toggle button not found.');
          }
        } else {
          console.error('Shopify Inbox: Chat host element not found or shadowRoot not accessible.');
        }
      } catch (error) {
        console.error('Error programmatically opening Shopify Inbox:', error);
      }
    });
  }
});
